import ApiService from './ApiService';

export default class LocationEnduserApi extends ApiService {
    getLocationRecents(payload) {
        return this.get('customer/locations/recent', payload, { noUseToken: true });
    }

    getLocationDetail(payload) {
        const { id, ...rest } = payload;
        return this.get(`customer/locations/${id}`, rest);
    }
}
